import InfoLabelValue from 'components/InfoLabelValue';
import Typography from 'components/Typography';
import styles from './index.module.scss';
import { useTheme } from 'hooks/theme';
import Button from 'components/Button';
import * as translations from 'intls/medicine';
import { useMemoTranslations } from 'hooks/Intl';

interface DocumentItemProps {
  vmp: VmpSummary;
}

const DocumentItem = ({ vmp }: DocumentItemProps) => {
  const { theme } = useTheme();
  const intl = useMemoTranslations(translations);

  return (
    <div className={`${styles.container} ${styles[theme]}`}>
      <div className={styles.header}>
        <Typography type="h6" weight="semibold" color="primary">
          {vmp.title}
        </Typography>
        <Button onClick={() => null} className={styles.detailsButton}>
          {intl.VIEW_DOCUMENT}
        </Button>
      </div>
      <div className="row">
        <InfoLabelValue
          customStyle="col-12 col-md-6"
          label={intl.ADMINISTRATION_ROUTE}
          value={vmp.route}
          valueClassName={styles.infoValue}
        />
        <InfoLabelValue
          customStyle="col-12 col-md-6"
          label={intl.PHARMACEUTICAL_FORM}
          value={vmp.galenic_form}
          valueClassName={styles.infoValue}
        />
      </div>
    </div>
  );
};

export default DocumentItem;
